export const API_BASE_PATH = '/api/v2'
export const CURRENT_USER_API_ENDPOINT = '/users/current'
export const RECOMMENDED_LOCALE_API_ENDPOINT = '/recommended_locale'
